module.exports = __webpack_public_path__ + "img/cover@2x.57227adc.png";